var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterOne8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3258 1H1.47578C1.10299 1 0.800781 1.30221 0.800781 1.675V13.825C0.800781 14.1978 1.10299 14.5 1.47578 14.5H16.3258C16.6986 14.5 17.0008 14.1978 17.0008 13.825V1.675C17.0008 1.30221 16.6986 1 16.3258 1Z",
    stroke: "#3B4443",
    strokeWidth: 1.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.80898 4.0374C4.80898 4.57329 4.37456 5.00771 3.83867 5.00771C3.30278 5.00771 2.86836 4.57329 2.86836 4.0374C2.86836 3.50151 3.30278 3.06709 3.83867 3.06709C4.37456 3.06709 4.80898 3.50151 4.80898 4.0374Z",
    fill: "#3B4443",
    stroke: "#3B4443",
    strokeWidth: 0.084375
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.18398 4.0374C8.18398 4.57329 7.74956 5.00771 7.21367 5.00771C6.67778 5.00771 6.24336 4.57329 6.24336 4.0374C6.24336 3.50151 6.67778 3.06709 7.21367 3.06709C7.74956 3.06709 8.18398 3.50151 8.18398 4.0374Z",
    fill: "#3B4443",
    stroke: "#3B4443",
    strokeWidth: 0.084375
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterOne8);
export default __webpack_public_path__ + "static/media/footer-one-8.afdadb2f127b1d699c2582ac2f61a359.svg";
export { ForwardRef as ReactComponent };